import React, { useEffect, useMemo } from 'react'
import { useInstData, useEventHandler } from '../../public/hooks'
import { hasChangedValues, getFormValue, changeItemsValue, getMergedValues, getListItems, addListItem, deleteListItem } from '../../public/utility'
// import FlowRecordDetail from './FlowRecordDetail'
import FlowRecordFlowForm from './FlowRecordFlowForm'
//import FlowRecordGridForm from './FlowRecordGridForm'
//import FlowRecordMailList from './FlowRecordMailList'
//import TreeSelect from '../../business/TreeSelect'

const FlowRecordDetail = props => {
	const { setState, me, me: {
		state: {
			components, subFlows, refreshing = true, id, processId, name, emailTemplet, actCdt, delCdt, status
		}
	} } = useInstData(props, useMemo(() => ({
		state: {
			id: props.match.params.id,
			status: props.match.params.status,
			processId: props.match.params.processId
		}
	}), []))

	const { onClose, onRefresh, mainFlowRecordId, onSubRecordFlowSaved, onSubRecordFlowDeleted, showBody: Body } = props

	// const handleShowDepSelectDiv = useEventHandler((title, onConfirm, onDelete) => {
	// 	const { initValues, changedValues, optionsParas } = me.state
	// 	const values = { ...initValues, ...changedValues, ...optionsParas }

	// 	Tyan.pubForm.showDialog(title, props => <TreeSelect {...props} initValues={{ ...values.obj部门, treeName: values.treeName, treeField: values.treeField }} onConfirm={onConfirm} onDelete={onDelete} />)
	// })

	const tryRefresh = () => {
		const { changedValues } = me.state
		const values = { ...changedValues }
		handleRefresh(values)
	}

	const fieldset = (() => {
		const loadComponent = ({ /* name,  */type, refresh, ...field }) => {
			const loadList = (field) => {
				const { list } = getListItems(me, '', field.name)
				var comps = [{ _label: field.label, minWidth: '100%' }]
				field.items && comps.push({ _label: field.items.map((o) => o.label).join("/"), minWidth: '100%', style: { 'color': 'green', 'font-weight': 'bold' } })

				comps.push(...(list && list.map((o) => ({
					_label: Object.keys(o).map((key) => {
						if (key != 'id') {
							if (typeof o[key] === 'number' && o[key] % 1 === 0 && (o[key] + '').length == 13) {
								try { return new Date(o[key]).toLocaleDateString() }
								catch (e) { return o[key] }
							} else
								return o[key]
						}

					}).join('/').replace(new RegExp('^\\/+', 'g'), ''), minWidth: '100%', style: { 'color': 'green', 'font-weight': 'bold' }
				}))))
				return comps
			}

			const loadGrid = (field) => {
				const { list } = getListItems(me, '', field.name)
				var comps = [{ _label: field.label, minWidth: '100%' }]
				field.columns && comps.push({ _label: field.columns.map((o) => o.name).join("/"), minWidth: '100%', style: { 'color': 'green', 'font-weight': 'bold' } })

				comps.push(...(list && list.map((o) => ({
					_label: field.columns.map((col) => {
						if (typeof o[col.name] === 'number' && o[col.name] % 1 === 0 && (o[col.name] + '').length == 13) {
							try { return new Date(o[col.name]).toLocaleDateString() }
							catch (e) { return o[col.name] }
						} else
							return o[col.name]
					}).join('/').replace(new RegExp('^\\/+', 'g'), ''), minWidth: '100%', style: { 'color': 'green', 'font-weight': 'bold' }
				}))))
				return comps
			}

			const loadDepSelect = (field) => {
				const { optionsParas } = me.state
				var options = []
				if (optionsParas && optionsParas.obj部门)
					options = optionsParas.obj部门[optionsParas.treeName].map(o => ({ text: optionsParas.obj部门[`${optionsParas.treeName}[${o}].fullName`], value: o }))
				return {
					_select: field._depselect, name: field.name + '_fullName', options, required: field.required, minWidth: '95%',
					onChange: (v) => {
						changeItemsValue(me, '', [field.name + '_id', field.name, field.name + '_fullName'], [v, optionsParas.obj部门[`${optionsParas.treeName}[${v}].${optionsParas.treeField}`], optionsParas.obj部门[`${optionsParas.treeName}[${v}].fullName`]])
					}
				}
			}

			field && (field.minWidth = '100%')
			refresh && (field.onChange = tryRefresh)
			type == '_depselect' && (field = loadDepSelect(field))
			if (type == '_group')
				return loadList(field)
			else if (type == '_grid')
				return loadGrid(field)
			else if (type == '_border') {
				var comps = [{ _label: field._border, minWidth: '100%' }]
				field.items && field.items.forEach(item => comps.push(...loadComponent(item)))
				return comps
			}
			return [field]
		}

		if (!components)
			return [{ _label: '装载中，请稍等...' }]
		var fieldset = []
		components && components.forEach(comp => fieldset.push(...loadComponent(comp)))
		return fieldset
		//return components.map(comp => loadComponent(comp))
	})()

	const handleLoadForm = () => {
		const { id, processId } = me.state
		const stamp = me.refreshStamp = Date.now()
		Tyan.doPostEvent('GetFlowRecordForm', {
			// showFetchSpinner: false,
			data: { id, processId },
			onEnd: ({ errorMessage, name, components, subFlows }) => {
				if (me.refreshStamp != stamp || me.unmounted) return
				if (errorMessage) {
					Ext.toast(`读取流程配置数据失败: ${errorMessage}`)
					//onClose()
					return
				}
				setState({ components, subFlows, name })
				handleRefresh()
			}
		})
	}

	const handleRefresh = (values = {}) => {
		const { id, processId } = me.state
		setState({ refreshing: true })
		const stamp = me.refreshStamp = Date.now()
		Tyan.doPostEvent('GetFlowRecord', {
			data: { id, processId, mainFlowRecordId, changedValues: values },
			onEnd: ({ errorMessage, initValues, optionsParas, initValuesOthers, emailTemplet, actCdt, delCdt }) => {
				if (me.refreshStamp != stamp || me.unmounted) return
				if (errorMessage) {
					Ext.toast(`读取流程数据失败: ${errorMessage}`)
					return
				}
				setState({ initValues, optionsParas, changedValues: values, initValuesOthers, emailTemplet, refreshing: false, actCdt, delCdt })
			}
		})
	}

	const handleSave = () => {
		const { id, processId } = me.state
		const values = getMergedValues(me, '')
		Tyan.doPostEvent({
			event: 'SaveFlowRecord',
			data: { id, processId, mainFlowRecordId, changedValues: values },
			onEnd: ({ errorMessage, id }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
				}
				else {
					Ext.toast('保存成功')
					setState({ id, processId })
					handleRefresh()
					onSubRecordFlowSaved && onSubRecordFlowSaved()
					// onRefresh && onRefresh()
					// onClose && onClose()
				}
			}
		})
	}

	const handlerDelete = () => {
		const { id } = me.state
		Tyan.pubForm.showConfirm('确定要删除？', () =>
			Tyan.doPostEvent({
				event: 'DeleteFlowRecord',
				data: { id },
				onEnd: ({ errorMessage }) => {
					if (errorMessage) {
						Tyan.pubForm.showError(errorMessage)
					}
					else {
						Ext.toast('删除成功')
						if (onSubRecordFlowDeleted)
							onSubRecordFlowDeleted()
						else {
							window.history.back()
							// onRefresh && onRefresh()
							// onClose && onClose()
						}
					}
				}
			}))
	}

	const handlePrint = () => {
		const { id } = me.state
		Tyan.pubForm.showExport({ event: 'PrintFlowRecord', eventData: { id } })
	}

	const bEdit = () => {
		return fieldset.filter(o => !o.disabled).length > 0
	}

	const handlerClose = () => {
		window.history.back()
		//onClose()
	}
	const bChanged = () => {
		return hasChangedValues(me)
	}

	const bSave = () => {
		const { changedValues } = me.state
		return changedValues && Object.keys(changedValues).length > 0
	}

	const _haveRequired = (o, values) => {
		if (o._border && !o.disabled)
			return o.items && o.items.filter(item => _haveRequired(item, values)).length > 0
		else
			return o.required && ((!o._files && (Object.keys(values).indexOf(o.name) == -1 || values[o.name] == null)) ||
				(o._files && (!getFormValue(me, '', o.name) || getFormValue(me, '', o.name).length == 0)))
	}

	const haveRequired = () => {
		const { initValues, changedValues } = me.state
		const values = { ...initValues, ...changedValues }
		return fieldset.filter(o => _haveRequired(o, values)).length > 0
	}

	useEffect(() => {
		handleLoadForm()
	}, [])

	const fieldset流转日志 = () => [{
		_html: '', name: '流转日志', minWidth: '95%', style: { textAlign: 'left' }
	}]

	const fieldsets = (() => [{
		title: name, name: '', _fieldset: fieldset, disabled: refreshing, docked: 'top', height: '68%',
	},
	{ title: '流转日志', name: 'Others', _fieldset: fieldset流转日志(), fullblock: true },
	])()

	return <Body data={me} maxWidth="1100"
		controls={
			[
				{ _recordflow: 'RecordFlow', icon: '', disabled: bSave() || haveRequired(), recordFlowForm: FlowRecordFlowForm, cdt: () => actCdt, onFinish: () => window.history.back() },
				{ _button: '保存', icon: '', handler: handleSave, disabled: !bSave() || haveRequired(), cdt: () => !refreshing && bEdit() && status != 0 },
				{ _button: '删除', icon: '', ui: 'action decline alt', cdt: () => id > 0 && !refreshing && delCdt && status != 0, handler: handlerDelete },
				//{ _button: '邮件', icon: '', cdt: () => emailTemplet && emailTemplet != '', handler: () => Tyan.pubForm.showDialog('邮件列表', FlowRecordMailList, { flowRecordId: id, emailTemplet }) },
				{ _button: '打印', icon: '', handler: handlePrint, cdt: () => id > 0 },
				{ _button: bChanged() && '取消' || '关闭', icon: '', handler: handlerClose },
			]
		}
		fieldsets={[...fieldsets]
		}
	/>
}

export default FlowRecordDetail